import React from 'react';
import isEqual from 'lodash.isequal';
import cloneDeep from 'lodash.clonedeep';
import classNames from 'classnames';
import SubmitDialog from '../submit-dialog';

function withPrompt(ModalComponent) {
  class PromptProvider extends React.Component {
    initialValues;

    static defaultProps = {
      data: null,
      handleCancel: Function.prototype,
      handleSubmit: Function.prototype,
      onOverlayClick: Function.prototype,
      modalRef: null,
      isValid: true,
      showPromptForce: false,
      overlay: 'transparent',
      containerClassName: '',
      promptCaptions: {
        title: 'Are you sure?',
        description: 'Really?',
        discard: 'Discard',
        submit: 'Submit',
        cancel: 'Cancel',
      },
      invalidPromptCaptions: undefined,
    };

    constructor(props) {
      super(props);

      this.state = {
        showPrompt: false,
      };

      this.showPrompt = this.showPrompt.bind(this);
      this.hidePrompt = this.hidePrompt.bind(this);
      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onPressEsc = this.onPressEsc.bind(this);

      // @ts-ignore TS(2339): Property 'data' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      const { data } = this.props;
      this.initialValues = cloneDeep(data);
    }

    onPressEsc() {
      // @ts-ignore TS(2339): Property 'overlay' does not exist on type 'Readonl... Remove this comment to see the full error message
      const { overlay, handleCancel } = this.props;

      if (overlay === 'visible') {
        this.handlePrompt();
        return;
      }
      // @ts-ignore TS2722: Cannot invoke an object which is possibly undefined
      handleCancel();
    }

    onOverlayClick() {
      // @ts-ignore TS(2339): Property 'overlay' does not exist on type 'Readonl... Remove this comment to see the full error message
      const { overlay, onOverlayClick, handleSubmit } = this.props;

      if (onOverlayClick !== Function.prototype) {
        // @ts-ignore TS2722: Cannot invoke an object which is possibly undefined
        onOverlayClick();
        return;
      }

      if (overlay === 'visible') {
        this.handlePrompt();
        return;
      }

      // @ts-ignore TS2722: Cannot invoke an object which is possibly undefined
      handleSubmit();
    }

    handlePrompt() {
      // @ts-ignore TS(2339): Property 'data' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      const { data: currentData, handleCancel, showPromptForce } = this.props;
      if (showPromptForce || !isEqual(this.initialValues, currentData)) {
        this.showPrompt();
        return;
      }

      // @ts-ignore TS2722: Cannot invoke an object which is possibly undefined
      handleCancel();
    }

    showPrompt() {
      this.setState({ showPrompt: true });
    }

    hidePrompt() {
      this.setState({ showPrompt: false });
    }

    render() {
      // @ts-ignore TS(2339): Property 'showPrompt' does not exist on type 'Read... Remove this comment to see the full error message
      const { showPrompt } = this.state;
      const {
        // @ts-ignore TS(2339): Property 'handleCancel' does not exist on type 'Re... Remove this comment to see the full error message
        handleCancel,
        // @ts-ignore TS(2339): Property 'handleSubmit' does not exist on type 'Re... Remove this comment to see the full error message
        handleSubmit,
        // @ts-ignore TS(2339): Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
        children,
        // @ts-ignore TS(2339): Property 'promptCaptions' does not exist on type '... Remove this comment to see the full error message
        promptCaptions,
        // @ts-ignore TS(2339): Property 'invalidPromptCaptions' does not exist on type
        invalidPromptCaptions,
        // @ts-ignore TS(2339): Property 'data' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        data,
        // @ts-ignore TS(2339): Property 'isValid' does not exist on type 'Readonl... Remove this comment to see the full error message
        isValid,
        // @ts-ignore TS(2339): Property 'modalRef' does not exist on type 'Readon... Remove this comment to see the full error message
        modalRef,
        // @ts-ignore TS(2339): Property 'overlay' does not exist on type 'Readonl... Remove this comment to see the full error message
        overlay,
        // @ts-ignore TS(2339): Property 'containerClassName' does not exist on ty... Remove this comment to see the full error message
        containerClassName,
        ...otherProps
      } = this.props;

      const useInvalidCaptions = invalidPromptCaptions && !isValid;
      const captions = useInvalidCaptions ? invalidPromptCaptions : promptCaptions;

      return (
        <React.Fragment>
          <ModalComponent
            {...otherProps}
            ref={modalRef}
            overlay={overlay}
            containerClassName={classNames(containerClassName, {
              'ws-modal-container--transparent': showPrompt,
            })}
            onOverlayClick={this.onOverlayClick}
            onPressEsc={this.onPressEsc}
            shouldDisablePointerEvents={!isValid}
          >
            {children}
          </ModalComponent>
          {showPrompt && (
            <SubmitDialog
              onDiscard={() => {
                this.hidePrompt();
                // @ts-ignore TS2722: Cannot invoke an object which is possibly undefined
                handleCancel();
              }}
              onSubmit={
                useInvalidCaptions
                  ? undefined
                  : () => {
                      this.hidePrompt();
                      // @ts-ignore TS2722: Cannot invoke an object which is possibly undefined
                      handleSubmit();
                    }
              }
              onCancel={() => {
                this.hidePrompt();
              }}
              // @ts-ignore TS(2322): Type '{ title: string; description: string; dis... Remove this comment to see the full error message
              captions={captions}
            />
          )}
        </React.Fragment>
      );
    }
  }

  return PromptProvider;
}

export default withPrompt;
